import React from 'react'
import { Link } from 'react-router-dom'
import { Restaurant } from '../types/restaurant'
import { useTranslation } from '../hooks/use-i18n'

interface RestaurantCardProps {
  restaurant: Restaurant
}

const RestaurantCard: React.FC<RestaurantCardProps> = ({ restaurant }) => {
  const { t } = useTranslation()
  return (
    <div className="bg-[#2a2a2a] border border-white/10 rounded-xl p-4 sm:p-6 transform hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:border-white/20">
      <div className="flex justify-between items-start mb-3 sm:mb-4 lg:mb-6 gap-2">
        <h3 className="text-sm sm:text-lg lg:text-xl font-semibold text-white truncate flex-1">
          {restaurant.name}
        </h3>
        <div className="flex flex-col gap-1 items-end">
          <span className="px-2 sm:px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-orange-500 text-white">
            {restaurant.restaurantType}
          </span>
        </div>
      </div>

      {/* Cuisines */}
      {restaurant.cuisines && restaurant.cuisines.length > 0 && (
        <div className="mb-3 sm:mb-4 lg:mb-6">
          <p className="text-white/80 text-xs sm:text-sm mb-1 sm:mb-2 lg:mb-3 font-medium">{t('restaurant.card.cuisines')}</p>
          <div className="flex flex-wrap gap-1 sm:gap-2">
            {restaurant.cuisines.slice(0, 3).map((cuisine) => (
              <span
                key={cuisine.id}
                className="bg-blue-500 text-white px-2 sm:px-3 py-1 rounded-full text-xs font-medium"
              >
                {cuisine.name}
              </span>
            ))}
            {restaurant.cuisines.length > 3 && (
              <span className="bg-blue-500 text-white px-2 sm:px-3 py-1 rounded-full text-xs font-medium">
                {t('restaurant.card.moreCuisines', { count: String(restaurant.cuisines.length - 3) })}
              </span>
            )}
          </div>
        </div>
      )}

      <div className="mb-3 sm:mb-4 lg:mb-6 space-y-1 sm:space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-white/80 text-xs sm:text-sm">{t('restaurant.card.members')}</span>
          <span className="text-white font-semibold text-xs sm:text-sm lg:text-base">
            {(restaurant.members?.length || 0) + 1}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-white/80 text-xs sm:text-sm">{t('restaurant.card.owner')}</span>
          <span className="text-white font-semibold text-xs sm:text-sm lg:text-base truncate ml-2">
            {restaurant.owner.name}
          </span>
        </div>
      </div>

      <div className="flex gap-2">
        <Link
          to={`/restaurant/${restaurant._id || restaurant.id}`}
          className="flex-1 bg-black hover:bg-black/80 text-white text-center py-2 sm:py-3 rounded-full transition-all duration-300 transform hover:scale-105 font-semibold text-xs sm:text-sm lg:text-base"
        >
          {t('restaurant.card.viewRestaurant')}
        </Link>
      </div>
    </div>
  )
}

export default RestaurantCard
